<template>

<div class="povrsine">
     <!-- <div class="glava">
        Slika v glavi
      </div>
  -->
    <div class="info">
          <h2> Priloga 2: Obseg površin vključenih v postopek certificiranja (Ta priloga je sestavni del zapisnika)</h2>
      </div>
      
      <div class="kmg">
        <div class="nosilec"><div>{{ pridelovalec.naziv }}</div><div>Priimek in ime</div></div>
        <div class="naslov"><div>{{pridelovalec.naslov}} {{pridelovalec.postnastevilka}} - {{pridelovalec.posta}}</div><div>Naslov</div></div>
        <div class="kontrolnast"><div>{{pridelovalec.kontrolnaStevilka}}</div><div>Kontrolna številka</div></div> 
		<div class="kmgmid"><div>{{pridelovalec.kmgmid}}</div><div>KMG-MID</div></div> 
      </div>
	  <div class="kmgpodatki"><div class="opis">Shema certificiranja</div><div>Integrirana pridelava</div></div>
	  <div class="kmgpodatki"><div class="opis">Področje</div><div>{{ kontrola.podrocjecertificiranja }}</div></div>
	  
      
    
    <table id="gerki">
         <colgroup>
        <col style="width:10%">
        <col style="width:10%">
        <col style="width:auto">
        <col style="width:20%">
        <col style="width:10%">
        <col style="width:5%">
        <col style="width:5%">
    
        
  </colgroup> 
        <thead>
        <tr>
            <th>Zap. št.</th>
            <th>GERK_PID</th>
            <th class="raba">Opis</th>
            <th>Domače ime</th>
            <th>Pov (a)</th>
			<th>V kontroli</th>
			<th>Ogled</th>
            
            

        </tr>
    </thead>
  <tr v-for="gerk in gerki" :key="gerk.gerkpid">
    <td>{{ gerk.st}}</td>
    <td>{{ gerk.gerkpid}}</td>
    <td>{{ gerk.raba}}</td>
    <td>{{ gerk.domaceime}}</td>
    <td>{{ gerk.povrsina.toFixed(0)}}</td>
	<td>{{ boolcheck(gerk.kontrolaIP)?"&check;":""}}</td>
	<td>{{ boolcheck(gerk.ogledIP)?"&check;":""}}</td>

    
  </tr>
  <tr class="vsota"><td>Število:</td><td>{{gerki.length}}</td><td colspan="1"></td><td>Vsota površin v kontroli:</td><td>{{gerki.reduce((a,i)=>{return a+i.povrsina;},0).toFixed()}}</td><td colspan="3"></td></tr>
</table>

<div class="kulture-wrapper mt-2">
<table style="width:100%">
         <colgroup>
        <col style="width:70%">
        <col style="width:30%">
  </colgroup> 
        <thead>
        <tr v-for="i in 3" :key="i">
            <th>Kultura</th>
            <th>Količina pridelka (kg)</th>
        
            
            

        </tr>
    </thead>
	</table>
	</div>
	<div class="kulture-wrapper">
		<table style="width:100%">
			<colgroup>
        <col style="width:70%">
        <col style="width:30%">
  </colgroup> 
  <tr v-for="kultura in pridelava.ip.prijava.obseg[kontrola.podrocjecertificiranja]" :key="kultura.naziv">
    <td>{{ kultura.naziv}}</td>
    <td>{{ kultura.kolicina}}</td>
    
  </tr>
  <tr v-for="i in (kulturelength>0?3-kulturelength:0)" :key="i">
    <td>&nbsp;</td>
    <td>&nbsp;</td>
    
  </tr>
  </table>
</div>
      
    
    <div class="podpis">
         <div class="podpisstranke">Podpis izvajalca</div>
        <div class="datumzig"><span>Datum</span><span>{{(new Date()).toLocaleDateString('SL-si')}}</span></div>
        <div class="ko">Podpis kontrolorja</div> 
    </div>
    <!--  <div class="noga"></div> -->

</div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { kontrolaService } from '../services/kontrola.service';

export default {
    props: ["sezona","pridelovalecid","kontrolaid"]
    ,
    
    created () {
       
      if(!this.sezona)
        this.dataSezona={sezona:Math.max(...this.sezonePisanje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};

    this.naloziPodatke();

    },
     data:function() {
        return {
			kontrola:{},
			pridelava:{ip:{prijava:{obseg:[]}}},
			kontakt:{},
			gerki:[],
            preslikava:[
 {
   "rabaid": 1180,
   "raba": "Trajne rastline na njivskih površinah",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1610,
   "raba": "Kmetijsko zemljišče v pripravi",
   "skupina": "Njivske površine"
 },
 {
   "rabaid": 1191,
   "raba": "Rastlinjak, kjer pridelava ni v tleh",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1161,
   "raba": "Hmeljišče v premeni",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1320,
   "raba": "Travinje z razpršenimi neupravičenimi značilnostmi",
   "skupina": "Travinje"
 },
 {
   "rabaid": 1230,
   "raba": "Oljčnik",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1100,
   "raba": "Njiva",
   "skupina": "Njivske površine"
 },
 {
   "rabaid": 1192,
   "raba": "Rastlinjak s sadnimi rastlinami",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1212,
   "raba": "Matičnjak",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1300,
   "raba": "Trajni travnik",
   "skupina": "Travinje"
 },
 {
   "rabaid": 1131,
   "raba": "Začasno travinje",
   "skupina": "Travinje"
 },
 {
   "rabaid": 1420,
   "raba": "Plantaža gozdnega drevja",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1221,
   "raba": "Intenzivni sadovnjak",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1181,
   "raba": "Trajne rastline na njiv. površinah, kjer pridelava ni v tleh",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1190,
   "raba": "Rastlinjak",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1170,
   "raba": "Jagode na njivi",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1411,
   "raba": "Površine za ukrep odprava zaraščanja",
   "skupina": "Travinje"
 },
 {
   "rabaid": 1160,
   "raba": "Hmeljišče",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1240,
   "raba": "Ostali trajni nasadi",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1211,
   "raba": "Vinograd",
   "skupina": "Specialne kulture"
 },
 {
   "rabaid": 1222,
   "raba": "Ekstenzivni oz. travniški sadovnjak",
   "skupina": "Specialne kulture"
 }
],
vrste:[{ime:"Njivske površine",vsota:null},{ime:"Travinje",vsota:null},{ime:"Specialne kulture",vsota:null}]
        }
    },
    computed: {
        kulturelength(){
			return this.pridelava.ip.prijava.obseg[this.kontrola.podrocjecertificiranja]?.length%3
		},
       ...mapState('gerk', ['gerk']),
        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('users', ['sezonePisanje']),
        vsotePovrsin:
        {
           get() {
            if(!this.gerki)
              return [];
            else{
                    var tmp=[];
                    for (var vrsta of this.vrste){
                        var tmpe={ime:vrsta.ime};
                        tmpe.povrsina=this.gerki.filter(g=>this.preslikava.find(p=>p.rabaid==g.rabaid).skupina==vrsta.ime).reduce((partialSum, a) =>(partialSum + a.povrsina), 0);
                        tmp.push(tmpe);

                    }
                        return tmp;
                }
            }             
          },
           
        },
   
    methods: {
		boolcheck(boolobject){
			if(!boolobject)
				return false
			else 
				return boolobject[this.kontrola.podrocjecertificiranja]
		},
		...mapActions({naloziGerke: 'gerk/load'}),
        ...mapActions('pridelava', ['loadIdPoSezoni','loadOne']),
        naloziPodatke(){


			let sezona=this.dataSezona.sezona;
            let pridelovalecid=this.pridelovalecid;
            let kontrolaid=this.kontrolaid;
            let shema="IP";
            let thisComp=this;
			kontrolaService.loadOne(sezona,pridelovalecid,shema,kontrolaid).then(
			   data=>{
                thisComp.kontrola=data;
				
			
            this.loadOne({sezona:sezona,pridelovalecid:pridelovalecid}).then(()=>{
				//ip.prijava.obseg[kontrola.podrocjecertificiranja]
				let p=thisComp.pridelovalec;

				let pridelava=thisComp.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema==shema);
				thisComp.pridelava=pridelava;
				let kontakt=p.kontakt.find(k=>k.vloga=="nosilec kmg")
                if(!kontakt)
				kontakt=p.kontakt.find(k=>k.glavni)
                if(!kontakt)
				kontakt=p.kontakt[0];

				thisComp.pridelovalec.kontrolnaStevilka=pridelava.kontrolnaStevilka;

			
				this.naloziGerke({sezona:sezona,pridelovalecid:thisComp.pridelovalec.kmgmid}).then(data=>{
					
					thisComp.gerki=
					thisComp.gerk
					.filter(g=>{
						if(!g.kontrolaIP)
							return false
						else 
							return g.kontrolaIP[this.kontrola.podrocjecertificiranja]
					})
					.sort((a,b)=>{
                			if (a.blokid>b.blokid)
                    			return 1;
                			else if(a.blokid==b.blokid)
                    			return a.gerkpid>b.gerkpid?1:-1
                			else
                    			return -1;
                    });
					

				},
				err=>{}
				);
             });
            },
			    err=>{}
			);
           },
    },

}

</script>


<style scoped>
@import '../styles/landscape.css';

.povrsine {
      margin: 15mm 15mm 15mm 15mm; 

}
.povrsine h2 {
      color:black;


}
.povrsine sub {
    font-size:smaller;
}


.glava{
    height:40mm;
    display:flex;
    align-items:center;
    justify-content:center;
    border:1px solid black;
}
.kmg{
    margin-top:8mm;
    display:flex;

}
.kmg>div{
    border:1px solid black;
}
.kmgpodatki{
	display:flex;
	
}
.kmgpodatki div {
	border:1px solid black;
	border-collapse: collapse;
	padding:2px;
	flex:1 1 80%;
	
}
.kmgpodatki div:first-child{
flex:1 1 20%;
}
.kmg div {
    text-align:center;
}
.kmg div div:nth-child(1) {
    font-size:1.2em;
    font-weight:bold;
}
.kmg div div:nth-child(2) {
    font-size:0.8em;
}
.kmg .nosilec {
    flex-grow:2;
}
.kmg .naslov {
    flex-grow:3;
}
.kmg .kontrolnast {
    flex-grow:1;
}
.kmg .kmgmid {
    flex-grow:1;
}


.info {
    margin-top:8mm;
}

#gerki {
     margin-top:2rem;   
}

.mt-2{
	margin-top:2rem; 
}
.kulture-wrapper{
	
	column-count: 3;
	column-gap: 0;
}
.povrsine .kulture-wrapper table,.povrsine .kulture-wrapper table th,.povrsine .kulture-wrapper table td {
    border:1px solid black;
    border-collapse:collapse;
	

}
.povrsine .kulture-wrapper table th,.povrsine .kulture-wrapper table td{
	text-align: left;
	padding:0 1mm;
    white-space: nowrap;


}


.povrsine table#gerki{
    width:100%;
}
.povrsine table#gerki,.povrsine table#gerki th,.povrsine table#gerki td {
    border:1px solid black;
    border-collapse:collapse;

}
.povrsine table#gerki td, .povrsine table#gerki th {
    padding:0 1mm;
    white-space: nowrap;
    width:1px;

}
.povrsine table#gerki .vsota, .dodatni-podatki table .vsota {
    font-weight:bold;
}

.podpis{
    margin-top:8mm;
    display:flex;

}
.podpis>div{
    border:1px solid black;
    padding-bottom:10mm;
}
.podpis div {
    text-align:center;
}
.podpis div div:nth-child(1) {
    font-size:1.2em;
    font-weight:bold;
}
.podpis div div:nth-child(2) {
    font-size:0.8em;
}
.podpis .podpisstranke {
    flex-grow:3;
}
.podpis .datumzig {
    flex-grow:1;
	display:flex;
	flex-direction: column;
	padding-bottom: 0px;
	gap:1rem;
}
.podpis .ko {
    flex-grow:3;
}

.dodatni-podatki{
    display:flex;
     justify-content: space-between;
    margin-top:8mm;
}

.povrsine .dodatni-podatki table,.povrsine .dodatni-podatki table th,.povrsine .dodatni-podatki table td {
    border:1px solid black;
    border-collapse:collapse;

}
.povrsine.dodatni-podatki table td, .povrsine .dodatni-podatki table th {
    padding:0 1mm;
    white-space: nowrap;
    

}
.dodatni-podatki table{
   
    table-layout: fixed;
}
.dodatni-podatki table thead tr:nth-child(1) th{
    word-wrap: break-word; 
    white-space: break-spaces;
    font-size:0.8em;
   
   
}
.dodatni-podatki .kulture {
    flex-grow:5;
    flex-shrink:1;
        width:80%;
        margin-left:8mm;
}
.dodatni-podatki .povrsina  col:nth-child(2),.dodatni-podatki .povrsina  col:nth-child(3){
    width:1px;
    }


.dodatni-podatki .povrsina {
    flex-grow:1;
    flex-shrink:1;
    width:35%;
}
.dodatni-podatki .povrsina tfoot {
    
}

.seznam-kultur {
    display:flex;
    margin-top:8mm;
    height: 2.5em;
}

.seznam-kultur>div:nth-child(1){
    display:flex;
}

.seznam-kultur>div:nth-child(2){
    border: 1px solid black;
    flex-grow:1;
    margin-left:8mm;
}
.seznam-kultur>div:nth-child(2)>div:nth-child(1){
    height: 50%;
    border-bottom: 1px solid black;

}
.dodatni-podatki table td:nth-child(2) 
{
text-align:right;
}
@media print {
  .dodatni-podatki {
    break-inside: avoid;
  }
}
</style>
